export class JSONTreeTemplate {
  key: any;
  value: any;
  isChildAvailable: boolean;
  isBlockCollapsed: boolean;
  metadata: any;
  metadataKeyList: any[];
  addBracket: boolean;
}
